
export default function MultidisciplinaryServices() {
  const services = [
    {
      icon: 'ri-walk-line',
      title: 'Fisioterapia',
      description: 'Rehabilitación física profesional'
    },
    {
      icon: 'ri-speak-line',
      title: 'Terapia del Lenguaje',
      description: 'Tratamiento de trastornos del habla'
    },
    {
      icon: 'ri-brain-line',
      title: 'Terapia Cognitiva',
      description: 'Estimulación y rehabilitación cognitiva'
    },
    {
      icon: 'ri-test-tube-line',
      title: 'Laboratorio a Domicilio',
      description: 'Toma de muestras en casa'
    },
    {
      icon: 'ri-lungs-line',
      title: 'Terapia Respiratoria',
      description: 'Tratamiento de afecciones respiratorias'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Nutrición',
      description: 'Planes nutricionales personalizados'
    },
    {
      icon: 'ri-syringe-line',
      title: 'Tratamiento Ambulatorio',
      description: 'Atención médica en casa'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: 'Hospitalización en Casa',
      description: 'Cuidado hospitalario domiciliario'
    }
  ];

  const equipment = [
    {
      icon: 'ri-bubble-chart-line',
      title: 'Concentradores de Oxígeno',
      description: 'Suministro continuo de oxígeno'
    },
    {
      icon: 'ri-drop-line',
      title: 'Parales de Suero',
      description: 'Soporte para infusiones'
    },
    {
      icon: 'ri-windy-line',
      title: 'Nebulizadores',
      description: 'Terapia de aerosol'
    },
    {
      icon: 'ri-suction-line',
      title: 'Equipos de Aspiración',
      description: 'Aspiración de secreciones'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: 'Camas Clínicas',
      description: 'Camas hospitalarias ajustables'
    }
  ];

  return (
    <section id="multidisciplinary" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-uri-teal/10 text-uri-teal text-sm font-semibold rounded-full mb-4">
            Servicio Asistencial Multidisciplinario
          </span>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Servicios Especializados
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Contamos con un equipo multidisciplinario de profesionales de la salud para brindar atención integral y humanizada a nuestros pacientes
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-uri-teal group cursor-pointer"
            >
              <div className="w-14 h-14 bg-uri-teal/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-uri-teal transition-colors">
                <i className={`${service.icon} text-2xl text-uri-teal group-hover:text-white transition-colors`}></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2 leading-tight">{service.title}</h4>
              <p className="text-sm text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Equipment Section */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-gray-100">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/3">
              <span className="inline-block px-4 py-1.5 bg-uri-green/10 text-uri-green text-sm font-semibold rounded-full mb-4">
                Alquiler de Equipos
              </span>
              <h4 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                Equipos Médicos Especializados
              </h4>
              <p className="text-gray-600 mb-6">
                Ofrecemos alquiler de equipos médicos de alta calidad para el cuidado en casa, garantizando comodidad y seguridad para el paciente.
              </p>
              <div className="flex items-center gap-3 text-uri-green">
                <i className="ri-shield-check-line text-2xl"></i>
                <span className="font-semibold">Equipos certificados y sanitizados</span>
              </div>
            </div>
            
            <div className="lg:w-2/3">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {equipment.map((item, index) => (
                  <div 
                    key={index}
                    className="bg-gray-50 rounded-xl p-5 hover:bg-uri-green/5 transition-colors group cursor-pointer"
                  >
                    <div className="w-12 h-12 bg-uri-green/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-uri-green transition-colors">
                      <i className={`${item.icon} text-xl text-uri-green group-hover:text-white transition-colors`}></i>
                    </div>
                    <h5 className="text-sm font-bold text-gray-900 mb-1">{item.title}</h5>
                    <p className="text-xs text-gray-600">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
